export default __webpack_public_path__ + "static/media/palindrome.dc0d2975.svg";